import { render } from "./App.vue?vue&type=template&id=b4d79c36"
import script from "./App.js?vue&type=script&lang=js"
export * from "./App.js?vue&type=script&lang=js"

import "./App.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__